export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Statistik der Touristenströme · Meldung an die Region",

  fields: {
    region: "Region",
    codice: "Betriebscode",
    codiceHint: "Von der Region vergebener Betriebscode (das Feld «codice»).",
    username: "Benutzername",
    password: "Passwort",
    passwordHint: "Zugangsdaten für den ROSS-1000-Webservice (von der Region / GIES vergeben).",
    prodotto: "Name der Software",
    camereDisponibili: "Verfügbare Zimmer",
    lettiDisponibili: "Verfügbare Betten",
    defaultTipoturismo: "Tourismusart (Standard)",
    defaultMezzotrasporto: "Verkehrsmittel (Standard)",
    useTestEndpoint: "Testumgebung verwenden",
    endpointResolved: "Endpunkt",
    keepBlank: "(leer lassen, um den aktuellen Wert zu behalten)",
  },

  regionOptions: {
    sardegna: "Sardinien",
    lazio: "Latium",
    veneto: "Venetien",
    emilia_romagna: "Emilia-Romagna",
    toscana: "Toskana",
    piemonte: "Piemont",
    lombardia: "Lombardei",
    liguria: "Ligurien",
    marche: "Marken",
    abruzzo: "Abruzzen",
    molise: "Molise",
    calabria: "Kalabrien",
    basilicata: "Basilikata",
  },

  actions: {
    saveAndVerify: "Speichern und prüfen",
    updateCredentials: "Zugangsdaten aktualisieren",
    verifyConnection: "Verbindung prüfen",
    saving: "Wird gespeichert...",
    verifying: "Wird geprüft...",
  },

  status: {
    connectionOk: "Zugangsdaten gespeichert und Verbindung erfolgreich geprüft.",
    connectionError: "Verbindungsfehler. Prüfen Sie die eingegebenen Zugangsdaten.",
    connectionPending: "Verbindung noch nicht geprüft. Klicken Sie auf «Verbindung prüfen», um sie zu bestätigen.",
  },

  validation: {
    codiceRequired: "Der Betriebscode ist erforderlich.",
    usernameRequired: "Der Benutzername ist erforderlich.",
    passwordRequired: "Das Passwort ist erforderlich.",
    capacityRequired: "Geben Sie die verfügbaren Zimmer und Betten an.",
  },

  toasts: {
    saveSuccess: "Zugangsdaten gespeichert und Verbindung erfolgreich geprüft.",
    saveWarning: "Zugangsdaten gespeichert, die Verbindung konnte aber nicht geprüft werden.",
    saveError: "Die Zugangsdaten konnten nicht gespeichert werden.",
    testSuccess: "ROSS-1000-Verbindung erfolgreich geprüft.",
    testError: "Die Verbindung konnte nicht geprüft werden.",
    statusActive: "ROSS 1000 aktiviert.",
    statusInactive: "ROSS 1000 deaktiviert.",
  },
};
